module.exports = __webpack_public_path__ + "static/media/youtube.32662b75.svg";